'use client';
import { Box, Container, Heading, Text } from '@chakra-ui/react';
import Image from 'next/image';
import React from 'react';

import { directusImageLoader } from '@/utils/loaders';

import Styles from './Banner.module.scss';

type Props = {
  bannerImage?: string | undefined | null;
  heading?: string;
  description?: string;
  warrantyImage?: string | undefined | null;
};

const BannerSection = ({
  bannerImage,
  heading,
  description,
  warrantyImage,
}: Props) => {
  return (
    <Box className={Styles.bannerWrapper}>
      <Box className={Styles.bannerImage}>
        <Image
          src={bannerImage ?? ''}
          loader={directusImageLoader}
          width={1920}
          height={379}
          alt={heading ?? ''}
        />
      </Box>

      <Container
        maxW={'1280'}
        width={'100%'}
        className={Styles.bannerContentWrapper}
      >
        <Box className={Styles.bannerContent}>
          <Box className={Styles.headingElement}>
            <Heading as="h1" className={Styles.titleLg} marginBottom={2}>
              {heading}
            </Heading>
          </Box>
          <Text className={Styles.bannerText}>{description}</Text>
          <Image
            src={warrantyImage ?? ''}
            width={72}
            height={90}
            alt={heading ?? ''}
            className={Styles.warantyImage}
          />
        </Box>
      </Container>
    </Box>
  );
};

export default BannerSection;
